import React, { useCallback, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { connect } from 'react-redux';
import { useDropzone } from 'react-dropzone'

function Attachment({ selected }) {
  const [invalid, setInvalid] = useState(false)
  const [attachments, setAttachments] = useState([]);

  const onDrop = useCallback(acceptedFiles => {
    setInvalid(false)

    if (acceptedFiles.length === 0) {
      setInvalid(true)
    } else {
      setAttachments(acceptedFiles);
      selected(acceptedFiles);
    }
  }, [selected]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: 'image/png, image/jpeg, application/pdf'
  });

  const removeFile = (removeIndex) => {
    const acceptedFiles = attachments.filter((attachment, index) => removeIndex !== index);

    setAttachments(acceptedFiles);
    selected(null);
  };

  return <>
    {invalid && <Alert variant='danger'>Invalid File Type</Alert>}
    {attachments.length === 0 &&
      <div {...getRootProps()} className="bg-light p-4 text-center text-muted border">
        <input {...getInputProps()} />
        {
          isDragActive ?
            <p className="m-0">Drop the files here ...</p> :
            <p className="m-0">Drag 'n' drop files here, or click to select files</p>
        }
      </div>
    }

    <ul>
      {attachments.map((file, index) => {
        return <li className="list" key={file.path}> {file.path} <a href="!#" onClick={(e) => { e.preventDefault(); removeFile(index) }}>Remove</a></li>
      })}
    </ul>

    <div>
      <small>Files must be JPG, PNG, or PDF</small>
    </div>
  </>
}

export default connect()(Attachment);